module.exports = __webpack_public_path__ + "static/media/filter.6b9fec96.svg";